import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse bg-gray-200 rounded-lg',
        className
      )}
    />
  );
}

// Skeleton para cards de profissionais
export function ProfessionalCardSkeleton() {
  return (
    <div className="card-kuiva">
      <div className="flex items-start gap-4">
        <Skeleton className="w-20 h-20 rounded-full flex-shrink-0" />
        <div className="flex-1 min-w-0 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-1/3" />
          <div className="flex gap-1 pt-1">
            <Skeleton className="h-6 w-16 rounded-full" />
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
          <Skeleton className="h-6 w-24 mt-2" />
        </div>
      </div>
    </div>
  );
}

// Skeleton para lista de profissionais
export function ProfessionalListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <ProfessionalCardSkeleton key={i} />
      ))}
    </div>
  );
}

// Skeleton para perfil
export function ProfileSkeleton() {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <Skeleton className="w-32 h-32 rounded-full mx-auto mb-4" />
        <Skeleton className="h-7 w-48 mx-auto mb-2" />
        <Skeleton className="h-5 w-32 mx-auto" />
      </div>
      <Skeleton className="h-24 w-full rounded-2xl" />
      <div className="space-y-3">
        <Skeleton className="h-5 w-32" />
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-20 rounded-full" />
          <Skeleton className="h-8 w-24 rounded-full" />
          <Skeleton className="h-8 w-16 rounded-full" />
        </div>
      </div>
      <Skeleton className="h-40 w-full rounded-2xl" />
    </div>
  );
}

// Skeleton para banner
export function BannerSkeleton() {
  return (
    <div className="rounded-3xl overflow-hidden">
      <Skeleton className="h-[280px] sm:h-[320px] w-full" />
    </div>
  );
}
